var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavelines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 691,
    viewBox: "0 0 1440 691",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.111111,
    d: "M-197.983 357.424C-88.7316 343.236 32.2494 326.418 261.126 335.331C490.002 344.245 569.695 344.769 707.479 319.176C845.263 293.583 887.243 294.965 1182.23 343.803C1477.75 392.731 1901.11 316.249 1901.11 316.249",
    stroke: "url(#paint0_linear_7_48)",
    strokeWidth: 1.11111
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.222222,
    d: "M-213.493 386.557C-104.046 368.492 17.1287 347.211 247.271 353.929C477.413 360.648 557.49 360.013 695.352 328.348C833.213 296.683 875.42 297.625 1172.86 349.365C1470.85 401.2 1894.49 306.394 1894.49 306.394",
    stroke: "url(#paint1_linear_7_48)",
    strokeWidth: 1.22222
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333333,
    d: "M-228.133 415.998C-118.591 394.046 2.65785 368.29 234.059 372.772C465.46 377.254 545.904 375.446 683.674 337.7C821.443 299.955 863.874 300.447 1163.96 355.016C1464.61 409.684 1888.02 296.525 1888.02 296.525",
    stroke: "url(#paint2_linear_7_48)",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444444,
    d: "M-241.893 445.731C-132.358 419.882 -11.1551 389.643 221.496 391.846C454.148 394.049 534.943 391.055 672.45 347.223C809.956 303.392 852.608 303.428 1155.54 360.746C1459.02 418.169 1881.7 286.638 1881.7 286.638",
    stroke: "url(#paint3_linear_7_48)",
    strokeWidth: 1.44444
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.555556,
    d: "M-254.765 475.736C-145.341 445.986 -24.3029 411.259 209.59 411.14C443.482 411.021 524.611 406.827 661.685 356.908C798.758 306.99 841.628 306.561 1147.58 366.544C1454.09 426.637 1875.52 276.729 1875.52 276.729",
    stroke: "url(#paint4_linear_7_48)",
    strokeWidth: 1.55556
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.666667,
    d: "M-266.742 505.997C-157.532 472.342 -36.7784 433.124 198.344 430.639C433.467 428.155 514.913 422.749 651.382 366.747C787.852 310.744 830.936 309.844 1140.1 372.401C1449.82 435.072 1869.49 266.795 1869.49 266.795",
    stroke: "url(#paint5_linear_7_48)",
    strokeWidth: 1.66667
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.777778,
    d: "M-277.817 536.496C-168.924 498.935 -48.575 455.225 187.767 450.332C424.108 445.439 505.853 438.81 641.547 376.729C777.242 314.649 820.538 313.27 1133.09 378.305C1446.21 443.459 1863.6 256.831 1863.6 256.831",
    stroke: "url(#paint6_linear_7_48)",
    strokeWidth: 1.77778
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.888889,
    d: "M-291.073 566.679C-182.6 525.213 -62.7762 477.015 174.771 469.67C412.319 462.324 494.344 454.458 629.093 386.312C763.843 318.166 807.346 316.299 1123.47 383.71C1440.17 451.245 1854.77 246.298 1854.77 246.298",
    stroke: "url(#paint7_linear_7_48)",
    strokeWidth: 1.88889
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-297.233 598.135C-189.283 552.768 -70.1041 500.087 168.635 490.245C407.375 480.403 489.662 471.289 623.296 397.092C756.929 322.895 800.637 320.533 1120.51 390.214C1440.96 460.022 1852.26 236.799 1852.26 236.799",
    stroke: "url(#paint8_linear_7_48)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_48",
    x1: 1931.98,
    y1: 352.578,
    x2: -197.612,
    y2: 384.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_48",
    x1: 1926.31,
    y1: 347.817,
    x2: -212.551,
    y2: 417.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_48",
    x1: 1920.98,
    y1: 343.018,
    x2: -226.504,
    y2: 449.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_48",
    x1: 1915.97,
    y1: 338.172,
    x2: -239.461,
    y2: 482.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_48",
    x1: 1911.3,
    y1: 333.271,
    x2: -251.412,
    y2: 515.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_48",
    x1: 1906.96,
    y1: 328.305,
    x2: -262.349,
    y2: 549.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_48",
    x1: 1902.95,
    y1: 323.266,
    x2: -272.263,
    y2: 583.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_48",
    x1: 1896.18,
    y1: 317.61,
    x2: -284.238,
    y2: 616.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_48",
    x1: 1895.91,
    y1: 312.935,
    x2: -288.996,
    y2: 651.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007871",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196285,
    stopColor: "#29E9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512878,
    stopColor: "#3094DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865668,
    stopColor: "#6229AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E1E",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavelines);
export default __webpack_public_path__ + "static/media/wavelines.725501fce7962c3e86b4dac20dc1f908.svg";
export { ForwardRef as ReactComponent };